import React from "react";
import { Route, Switch } from "react-router-dom";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";
import Steps from "./components/Steps";
import ChangePassword from "./containers/ChangePassword";
import SocialContent from "./containers/SocialContent";
import Home from "./containers/Home";
import Login from "./containers/Login";
import NotFound from "./containers/NotFound";
import ResetPassword from "./containers/ResetPassword";
import Sticker from "./containers/Sticker";
import Stamps from "./containers/Stamps";
import Story from "./containers/Story";
import ThankYou from "./containers/ThankYou";
import Upgrade from "./containers/Upgrade";
import Logout from "./containers/Logout";

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/logout">
        <Logout />
      </Route>

      <UnauthenticatedRoute exact path="/">
        <Login />
      </UnauthenticatedRoute>
      <UnauthenticatedRoute exact path="/login/reset">
        <ResetPassword />
      </UnauthenticatedRoute>
      <AuthenticatedRoute exact path="/home">
        <Home />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/sticker">
        <Steps activeTab="sticker"/>
        <Sticker />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/story">
        <Steps activeTab="story"/>
        <Story />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/stamps">
        <Steps activeTab="stamps"/>
        <Stamps />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/socialcontent">
        <Steps activeTab="socialcontent"/>
        <SocialContent />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/thankyou">
        <ThankYou />
      </AuthenticatedRoute>
      <Route exact path="/upgrade">
        <Upgrade />
      </Route>
      
      <AuthenticatedRoute exact path="/settings/password">
        <ChangePassword />
      </AuthenticatedRoute>
      
        {/* Finally, catch all unmatched routes */}
      <Route>
        <NotFound />
      </Route>
    </Switch>
  );
}